import LinksList from "@/components/Elements/LinksList";
import { useModelLink } from "@/modules/model-link";

const UsersLinksList = ({ users }) => {
  const { getModelLink } = useModelLink();

  const links = users?.map((user) => ({
    label: user.name,
    to: getModelLink("user", user),
    popover: user.email,
  }));

  return <LinksList links={links} />;
};

export default UsersLinksList;
